var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8701 23.3574L22.8902 23.1658L22.7133 23.2406C21.4079 23.7918 19.3476 24.4507 16.9427 24.4507C15.3109 24.4507 13.7064 24.1514 12.1749 23.5582C8.12179 21.9903 4.54456 18.4019 1.54166 12.8897L1.40491 12.6396L1.33198 12.9153C0.983741 14.2386 0.806885 15.6111 0.806885 16.9965C0.806885 24.3029 5.7315 30.6784 12.7839 32.5018C13.7101 32.7409 14.6782 32.8979 15.661 32.9655C15.7995 32.9746 15.9363 32.9801 16.0712 32.9801C18.4651 32.9801 20.6148 31.5235 21.5045 29.2547C22.1919 27.508 22.6495 25.524 22.8701 23.3574Z",
    fill: "#004990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0183 9.63173C30.0082 7.68238 28.0172 6.46677 25.8256 6.45947C25.8019 6.45947 25.7782 6.45947 25.7527 6.45947C23.016 6.45947 20.396 6.95046 18.1716 7.88315L17.9637 7.97077L18.157 8.08576C21.7507 10.2176 24.9049 13.8608 25.2586 14.2751L25.8512 14.9833H23.9094V19.4205C23.9094 19.8238 23.9057 20.2272 23.8948 20.6306C23.8766 21.3552 23.8419 22.0597 23.7891 22.7241C23.4846 26.5297 22.5602 29.6509 20.9685 32.2628L20.819 32.5092L21.0961 32.4326C27.9917 30.5179 32.8069 24.1715 32.8069 17.0002C32.8069 14.4357 32.1888 11.8895 31.0183 9.63173Z",
    fill: "#004990"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93595 21.4482L10.111 21.5613V14.9832H8.16739L8.76177 14.2768C9.16289 13.8022 12.7966 9.58231 16.8242 7.55995C19.9821 5.97747 23.7818 5.31856 27.8166 5.65623L28.1339 5.68361L27.9042 5.46275C24.9104 2.57158 20.9685 0.97998 16.806 0.97998C11.4347 0.97998 6.44988 3.6576 3.4725 8.14037C2.23086 10.0112 2.21263 12.479 3.43056 14.4265C5.3851 17.5549 7.57483 19.9168 9.93595 21.4482Z",
    fill: "#004990"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4687 15.0508H14.2917V17.2356H16.4687V15.0508Z",
    fill: "#004990"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7305 15.0508H17.5535V17.2356H19.7305V15.0508Z",
    fill: "#004990"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4687 18.3215H14.2917V20.4936H16.4687V18.3215Z",
    fill: "#004990"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7305 18.3215H17.5535V20.4936H19.7305V18.3215Z",
    fill: "#004990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsrIcon);
export default __webpack_public_path__ + "static/media/MSRIcon.09f15aa3b962a10c8de72ac217e04cea.svg";
export { ForwardRef as ReactComponent };